
import authService from "@/api/authService";
import menuService from "@/api/menuService";
import MessageService from "@/utils/message";
import tokenService from "@/utils/tokenService";
import { computed, onMounted } from "@vue/runtime-core";
import { message } from "ant-design-vue";
import { random } from "lodash";
import { toRefs } from "vue";
import { Options, setup, Vue } from "vue-class-component";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
const menuJson = require("@/assets/js/menu.json")

@Options({
  name: "loading",
})
export default class Loading extends Vue {
  info = setup(() => {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const {getTargetUrl} = toRefs(store.getters);

    const randomStr = (len:number)=>{
      len = len || 6;
      let arr:any = [];
      for(let i=0;i<len;i++){
        let code = Math.ceil(Math.random() * 58) + 65
        console.log('code', code)
        arr.push(code)
      }
      return arr.map((el:any) => {return String.fromCharCode(el)}).join('');
    }

    const getTicket = () => {
      let query = route.query || {};
      let url = getTargetUrl.value;
      if (query.ticket) {
        authService.validateCASSTToken(query.ticket + "", url).then((result:any) => {
          if (result.data.token) {
            let menuList:any = menuJson;
            store.commit('setMenuList', menuList);
            // MessageService.info("登录成功，即将跳转！");
            tokenService.setToken(result.data.token);
            getMenuList();
            // router.replace('workbench');
          }
        }).catch(e=>{
          message.success('系统登录失败，请检查账号是否同步...')
          setTimeout(() => {
            window.location.href = `https://wxct.wxskii.com:8655/wui/index.html#/?appid=b6dd4071-1bb8-4adc-a4bd-21372a2f6caa&service=${encodeURIComponent(url)}&_key=${randomStr(6)}`;
          }, 1000)
        })
        // message.success('登录成功，系统正在加载中...')
        // setTimeout(() => {
        //   router.push('workbench')
        // }, 2000)
      } else {
        message.success('请重新登录系统...')

        setTimeout(() => {
          window.location.href = `https://wxct.wxskii.com:8655/wui/index.html#/?appid=b6dd4071-1bb8-4adc-a4bd-21372a2f6caa&service=${encodeURIComponent(url)}&_key=${randomStr(6)}`;
          // window.location.href = "https://wxct.wxskii.com:8655/wui/index.html#/?appid=b6dd4071-1bb8-4adc-a4bd-21372a2f6caa&service=http%3A%2F%2Fwxct.wxskii.com%3A8001%2F&_key=wmtmpr";
          // router.push('login');
        }, 1000)
      }
    }

    const getMenuList = () => {
      menuService.getMenuList().then((result: any) => {
        let menuList = result.result;
        if (menuList.length === 0) {
          MessageService.error("您没有权限访问,请联系管理员开通相关权限！");
          return;
        }
        store.commit("setMenuList",[{data:menuList}]);
        MessageService.info("登录成功，即将跳转！");
        console.log(result);
        setTimeout(() => {
          router.replace("/workbench");
        }, 500);
      });
    }

    onMounted(() => {
      getTicket();
      console.log(router, route.query)
    })
    return {};
  });
}
